<template>
  <Dropdown ref="dropdown" append-to-body>
    <template #button="{ open }">
      <button
        type="button"
        class="p-2 rounded-full bg-transparent hover:bg-gray-200 focus:outline-none"
        @click="open"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4"
          viewBox="0 0 24 24"
          stroke-width="2"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <circle cx="12" cy="12" r="1" />
          <circle cx="12" cy="19" r="1" />
          <circle cx="12" cy="5" r="1" />
        </svg>
      </button>
    </template>

    <div
      class="origin-top-right absolute right-0 mt-2 max-w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="options-menu"
    >
      <div class="py-1">
        <button
          v-if="$membershipHasPermissionTo('create email templates')"
          type="button"
          class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
          role="menuitem"
          @click="handleDuplicate"
        >
          Duplicate
        </button>
      </div>
      <div v-if="$membershipHasPermissionTo('delete email templates')" class="py-1">
        <button
          type="button"
          class="group flex items-center px-4 py-2 focus:outline-none w-full text-sm text-red-700 hover:bg-red-100 hover:text-red-900"
          role="menuitem"
          @click="handleDelete"
        >
          Delete
        </button>
      </div>
    </div>
  </Dropdown>
</template>

<script>
import { emailTemplatesClient } from '@/api/clients';

export default {
  props: {
    emailTemplate: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleDuplicate() {
      this.$modal.show({
        component: () => import('./DuplicateEmailCampaignDialog.vue'),
        props: {
          emailTemplateId: this.emailTemplate.id,
        },
        on: {
          duplicated: () => {
            this.$emit('duplicated');
          },
        },
        hideEvent: 'close',
      });
    },
    handleDelete() {
      this.$modal.show({
        component: () => import('./DeleteEmailTemplateDialog.vue'),
        props: {
          action: async (emailTemplateId) => {
            try {
              await emailTemplatesClient.destroy(emailTemplateId);

              return Promise.resolve();
            } catch (error) {
              return Promise.reject(error);
            }
          },
          emailTemplate: this.emailTemplate,
        },
        on: {
          deleted: () => {
            this.$emit('deleted');
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
